import { Helmet } from "react-helmet";

const DefaultHelmet = () => {
  // Check if we're on a landing page - if so, don't render default meta tags
  // Landing pages have their own SEO management via SeoHead component
  const currentPath = window.location.pathname;
  const isLandingPage = currentPath.startsWith('/landing/');

  if (isLandingPage) {
    // On landing pages, only render essential meta tags
    // The SeoHead component will handle description, keywords, canonical, etc.
    return (
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Lokalny Trener - Znajdź Lokalnych Ekspertów</title>
      </Helmet>
    );
  }

  return (
    <Helmet>
      {/* Default meta tags for non-landing pages */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="author" content="Lokalny Trener" />
      <meta
        name="description"
        content="Łączymy osoby szukające pomocy z najlepszymi ekspertami! Fitness, języki, korepetycje, programowanie – dodaj ogłoszenie lub znajdź idealnego specjalistę. Dołącz do naszej społeczności już dziś!"
      />
      <meta
        name="keywords"
        content="lokalny, trener, fitness, język, korepetycje, programowanie, ogłoszenia"
      />
      <meta
        property="og:title"
        content="Front Lokalny Trener - Znajdź Lokalnych Ekspertów"
      />
      <meta
        property="og:description"
        content="Łączymy osoby szukające pomocy z najlepszymi ekspertami! Fitness, języki, korepetycje, programowanie – dodaj ogłoszenie lub znajdź idealnego specjalistę. Dołącz do naszej społeczności już dziś!"
      />
      <meta
        property="og:url"
        content={`${process.env.REACT_APP_FRONTEND_URL}`}
      />
      <link rel="canonical" href={`${process.env.REACT_APP_FRONTEND_URL}`} />
      <title>Lokalny Trener - Znajdź Lokalnych Ekspertów</title>
    </Helmet>
  );
};

export default DefaultHelmet;
